import { render, staticRenderFns } from "./BadgesListsChips.vue?vue&type=template&id=38da7ec2"
import script from "./BadgesListsChips.vue?vue&type=script&lang=js"
export * from "./BadgesListsChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports